import XLSX from 'xlsx'

function toYuan(fen) {
  return ((Number(fen) || 0) / 100).toFixed(2)
}

function metricFields(item) {
  return {
    '拍照次数': Number(item.photoCount || 0),
    '支付笔数': Number(item.payCount || 0),
    '支付金额': toYuan(item.amountTotal),
    '退款笔数': Number(item.refundCount || 0),
    '退款金额': toYuan(item.refundAmount)
  }
}

function metricTotal(list) {
  const sum = (key) => list.reduce((s, row) => s + (Number(row[key]) || 0), 0)
  return {
    '拍照次数': sum('photoCount'),
    '支付笔数': sum('payCount'),
    '支付金额': toYuan(sum('amountTotal')),
    '退款笔数': sum('refundCount'),
    '退款金额': toYuan(sum('refundAmount'))
  }
}

function fileName(title, begin, end) {
  const range = begin && end ? `_${begin}_${end}` : ''
  return `${title}${range}.xlsx`
}

function ExportExcel(data, downloadName) {
  if (!data || !data.length) return

  const worksheet = XLSX.utils.json_to_sheet(data)
  const headers = Object.keys(data[0])
  worksheet['!cols'] = headers.map((header) => {
    let max = String(header).length
    data.forEach((row) => {
      const len = String(row[header] == null ? '' : row[header]).length
      if (len > max) max = len
    })
    return { wch: Math.min(Math.max(max + 2, 10), 40) }
  })

  const workbook = {
    Sheets: { data: worksheet },
    SheetNames: ['data']
  }
  const output = XLSX.write(workbook, {
    bookType: 'xlsx',
    type: 'binary'
  })
  const blob = new Blob([s2ab(output)], {
    type: 'application/octet-stream'
  })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = downloadName || 'export.xlsx'
  document.body.appendChild(link)
  link.click()
  setTimeout(() => {
    URL.revokeObjectURL(url)
    document.body.removeChild(link)
  }, 0)
}

function s2ab(text) {
  const buffer = new ArrayBuffer(text.length)
  const view = new Uint8Array(buffer)
  for (let i = 0; i < text.length; i++) {
    view[i] = text.charCodeAt(i) & 0xFF
  }
  return buffer
}

export default {
  ExportExcel,
  toYuan,
  metricFields,
  metricTotal,
  fileName
}
